// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app{display:flex;flex-direction:column;min-height:100vh;font-family:var(--font-family-primary)}.main-container.v-container{padding:0;max-width:100%}#content-container{flex-grow:1;margin-bottom:var(--spacing-lg)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
